<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="card  contactEdition">
            <header class="header-card">
              <p>
                {{ $t('catalogue.newProduct.informations') }}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <div class="column is-6 is-marginless">
                  <b-field :label="$t('catalogue.newProduct.startDate')"
                           class="obligatoire">
                    <b-datepicker show-week-number
                      nearby-selectable-month-days
                      :class="{'is-danger': dateHasError}"
                      icon="calendar-today"
                      :editable="true"
                      v-model="produit.produitReseauNumerique.dateDebut">
                    </b-datepicker>
                  </b-field>
                </div>
                <div class="column is-6 is-marginless">
                  <b-field :label="$t('catalogue.newProduct.endDate')">
                    <b-datepicker show-week-number
                      nearby-selectable-month-days
                      :class="{'is-danger': endDateHasError}"
                      icon="calendar-today"
                      :editable="true"
                      :min-date="produit.produitReseauNumerique.dateDebut"
                      v-model="produit.produitReseauNumerique.dateFin">
                    </b-datepicker>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <parametre-autocomplete
                  v-model="produit.produitReseauNumerique.formatId"
                  @select="produit.produitReseauNumerique.format = $event"
                  :label="$t('catalogue.newProduct.format')"
                  :target="constantes.PARAMETRES_KEYS.format"
                  class="column is-6 is-marginless"
                  required
                />
                <parametre-autocomplete
                  :label="$t('catalogue.newProduct.reseauType')" class="column is-6 is-marginless"
                  v-model="produit.produitReseauNumerique.typeReseauId"
                  :target="constantes.PARAMETRES_KEYS.typeReseau"
                  expanded
                />
              </div>
              <div class="columns">
                <b-field :label="$t('catalogue.newProduct.reseauCategorie')"
                         class="column is-6 is-marginless obligatoire"
                         :type="categorieHasError">
                  <b-select v-model="produit.produitReseauNumerique.categorie" expanded>
                    <option :value="null" disabled>
                      {{ $t('catalogue.newProduct.reseauCategoriePlaceholder') }}
                    </option>
                    <option v-for="categorieReseau in listeCategoriesReseau"
                            :key="categorieReseau.code"
                            :value="categorieReseau.code">
                      {{ $t(categorieReseau.libelle) }}
                    </option>
                  </b-select>
                </b-field>
                <b-field :label="$t('catalogue.newProduct.confrere')"
                         class="column is-6 is-marginless">
                  <b-autocomplete
                    :value="libelleConfrere"
                    :open-on-focus="false"
                    :data="confreres"
                    field="nomCommercial"
                    :placeholder="$i18n.t('general.autocomplete.search')"
                    @input="getConfrere"
                    :loading="isFetching"
                    @select="setConfrere">
                    <template slot="empty">
                      <div v-if="!isFetching">
                        {{$t('general.autocomplete.noRslt')}}
                      </div>
                      <div v-else>
                        {{$t('general.autocomplete.search')}}
                      </div>
                    </template>
                  </b-autocomplete>
                </b-field>
              </div>
              <div class="columns">
                <b-field :label="$t('catalogue.newProduct.nbDiffusionMax')"
                         class="column is-6 is-marginless">
                  <b-input type="number"
                           v-model="produit.produitReseauNumerique.nombreDiffusionJour">
                  </b-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-adresse :adresseReseau="produit.produitReseauNumerique.adresse"
      :produit="produit"
       :tableName="PRODUIT">
    </app-adresse>
  </div>
</template>

<script>

import moment from 'moment';
import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import { CATEGORIES_RESEAU } from '@/configuration/catalogue/produitConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import appAdresse from '@/components/catalogue/m_adresseCaracteristiqueReseau';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import getAllConfrere from '@/services/tiers/getAllConfrere';
import { PRODUIT } from '@/configuration/ville/villeConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  components: {
    appAdresse,
    ParametreAutocomplete,
  },
  data() {
    return {
      PRODUIT: PRODUIT,
      listeCategoriesReseau: CATEGORIES_RESEAU,
      address: '',
      confreres: [],
      libelleConfrere: null,
      isFetching: false,
      constantes: {
        PARAMETRES_KEYS: typesParametres.PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    categorieHasError() {
      return this.$parent.error && !this.produit.produitReseauNumerique.categorie ? 'is-danger' : '';
    },
    dateHasError() {
      return this.$parent.error && !this.produit.produitReseauNumerique.dateDebut ? 'is-danger' : '';
    },
    formatHasError() {
      return this.$parent.error && !this.produit.produitReseauNumerique.formatId ? 'is-danger' : '';
    },
    endDateHasError() {
      if (!(this.produit.produitReseauNumerique.dateDebut
        && this.produit.produitReseauNumerique.dateFin)) {
        return '';
      }
      const dateDebut = moment(this.produit.produitReseauNumerique.dateDebut);
      const dateFin = moment(this.produit.produitReseauNumerique.dateFin);
      if (dateDebut > dateFin && this.$parent.error) {
        return 'is-danger';
      }
      return '';
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.libelleConfrere = this.produit.tiers ? this.produit.tiers.nomCommercial : null;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getConfrere: debounce(async function confrereData(text) {
      if (text === this.libelleConfrere) return;
      try {
        this.libelleConfrere = text;
        this.produit.tiersId = null;
        this.isFetching = true;
        this.confreres = await getAllConfrere({
          societeId: this.societeActiveId,
          nomCommercial: text,
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }),
    setConfrere(newConfrere) {
      if (!newConfrere) return;
      this.libelleConfrere = newConfrere.nomCommercial;
      this.produit.tiersId = newConfrere.id;
    },
  },
};
</script>
